import { ProgramCategories } from 'src/features/program-categories/program-category'
import {
  DrawerClose,
  DrawerContent,
} from '@/modules/components/ui/drawer'
import { SearchInput } from '~shared/components/search-input'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { CarouselDrawer } from '~shared/components/carousel-drawer'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { X } from 'lucide-react'
import { useBreakpoint } from '~shared/hooks/useBreakpoint'

type Props = {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
  popularPrograms: Awaited<ReturnType<typeof getPopularPrograms>>
}

export const HeaderDrawer: React.FC<Props> = ({
  categories,
  popularPrograms
}) => {
  const breakpoint = useBreakpoint()
  return (
    <DrawerContent
      className='container w-full px-[16px] box-border
    md:px-0  md:max-w-[704px]  md:left-[calc(50%-360px)]
    xl:left-[calc(50%-630px)]
    lg:left-[calc(50%-485px)] lg:max-w-[955px]
    2xl:left-[calc(50%-775px)]'>
      {breakpoint === 'xs' && (
        <DrawerClose asChild className='absolute top-[10px] right-[16px] '>
          <span className='w-[40px] h-[40px] bg-accent flex items-center justify-center rounded-full cursor-pointer'>
            <X className='max-h-[20px] max-w-[20px] text-white' />
          </span>
        </DrawerClose>
      )}

      <div className='rounded-[24px] lg:rounded-[40px] bg-white p-[16px] pr-[8px] md:pr-0 mt-[60px] lg:mt-[100px]'>
        <div
          className='w-full max-h-[calc(100dvh-110px)]  overflow-y-auto pr-[8px]   md:max-h-none md:overflow-visible
      lg:grid-cols-[487px_355px]  lg:gap-[40px]
      md:grid-cols-[280px_355px]   md:gap-[16px] md:grid md:p-[24px]'>
          <div className='w-full min-h-[330px]'>
            <SearchInput
              categories={categories}
              isDrawer
              className='h-[50px] md:h-[67px]'
            />
            <ProgramCategories categories={categories} isDrawer />
          </div>
          <CarouselDrawer popularPrograms={popularPrograms} />
        </div>
      </div>
    </DrawerContent>
  )
}
